/** Frekans optimizasyon metod seçenekleri */
export const FREQUENCY_METHOD_OPTIONS = [
  { value: "method1", label: "M1", methodNum: 1 },
  { value: "method2", label: "M2", methodNum: 2 },
  { value: "method3", label: "M3", methodNum: 3 },
  { value: "method4_beta10", label: "M4 β10", methodNum: 4 },
  { value: "method4_beta20", label: "M4 β20", methodNum: 4 },
  { value: "method4_beta30", label: "M4 β30", methodNum: 4 },
  { value: "method5", label: "M5", methodNum: 5 },
  { value: "method6", label: "M6", methodNum: 6 },
];

export const ALL_METHOD_VALUES = FREQUENCY_METHOD_OPTIONS.map((m) => m.value);

export const SYNC_YON_OPTIONS = ["Gidiş", "Dönüş", "1", "2"];

let syncRuleCounter = 0;

export function createSyncRule(overrides = {}) {
  syncRuleCounter += 1;
  return {
    id: `sync-${Date.now()}-${syncRuleCounter}`,
    Kaynak_Hat: "",
    Kaynak_Yon: "Gidiş",
    Kaynak_Durak: 1,
    Hedef_Hat: "",
    Hedef_Yon: "Gidiş",
    Hedef_Durak: 1,
    Baslangic_Saat: "07:00",
    Bitis_Saat: "09:00",
    Tampon_Sure: 2,
    Oncelik: 1,
    Aktif: "Evet",
    ...overrides,
  };
}

export function isSyncRuleActive(rule) {
  const aktif = rule?.Aktif;
  return aktif === "Evet" || aktif === "EVET" || aktif === true;
}
